import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Utilities } from "../../utils/utilities";

@Component({
  selector: 'app-color-notation',
  templateUrl: './color-notation.component.html',
  styleUrls: ['./color-notation.component.scss']
})
export class ColorNotationComponent implements OnChanges {

  @Input() nameColorMap: Map<string, string>;

  names: string[];
  namesRange: number[];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    this.names = Array.from(this.nameColorMap.keys());
    this.namesRange = this.getNamesRange();
  }

  private getNamesRange(): number[] {
    return Utilities.range(0, this.names.length, 2);
  }

}
